import Axios from "../../../_helpers/axiosHelper";
import { IResponseAppointment } from "../reducers";

export const getAppointment = (id: string): Promise<IResponseAppointment> => {
  return Axios.get(`/appointment/${id}`);
};
export const updateAppointment = (id: string, data: any): Promise<any> => {
  return Axios.put(`/appointment/${id}`, data);
};
export const confirmAppointmentStatus = (id: string): Promise<any> => {
  return Axios.get(`/appointment-confirmation-status/${id}`);
};
export const confirmAppointment = (id: string): Promise<any> => {
  return Axios.get(`/appointment-confirmation/${id}`);
};
